import React, { Suspense, lazy } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import useCurrentUser from '~/hooks/useCurrentUser';

import ProductPerformanceRouteGate from './ProductPerformance/ProductPerformanceRouteGate';

// Direct report routes only; Library publication is managed separately.
export const COMMERCIAL_REPORT_ROUTES = [
  {
    pageId: 'flash-funnel',
    path: '/commercial-ops/flash-funnel',
    Component: lazy(() => import('./FlashFunnel/FlashFunnelPage')),
  },
  {
    pageId: 'contribution-margin',
    path: '/commercial-ops/contribution-margin',
    Component: lazy(() => import('./ContributionMargin/ContributionMarginPage')),
  },
  {
    pageId: 'performance-marketing',
    path: '/commercial-ops/performance-marketing',
    Component: lazy(() => import('./PerformanceMarketing/PerformanceMarketingPage')),
  },

  {
    pageId: 'countries',
    path: '/commercial-ops/countries',
    Component: lazy(() => import('./Countries/CountriesPage')),
  },
  {
    pageId: 'commercial-kpi-tracker',
    path: '/commercial-ops/commercial-kpi-tracker',
    Component: lazy(() => import('./CommercialKpiTracker/CommercialKpiTrackerPage')),
  },
  {
    pageId: 'customer-comms',
    path: '/commercial-ops/customer-comms',
    Component: lazy(() => import('./CustomerComms/CustomerCommsPage')),
  },
  { pageId: 'luxplus', path: '/commercial-ops/luxplus', Component: lazy(() => import('./LuxPlusLive/LuxPlusPage')) },
  {
    pageId: 'flash-post-campaign',
    path: '/commercial-ops/flash-post-campaign',
    Component: lazy(() => import('./FlashPostCampaign/FlashPostCampaignPage')),
  },

  {
    pageId: 'inspiration-blog-performance',
    path: '/commercial-ops/inspiration-blog-performance',
    Component: lazy(() => import('./BlogEmailReports/InspirationBlogPerformancePage')),
  },
  {
    pageId: 'email-clicks-by-day',
    path: '/commercial-ops/email-clicks-by-day',
    Component: lazy(() => import('./BlogEmailReports/EmailClicksByDayPage')),
  },
  {
    pageId: 'lpc-post-campaign',
    path: '/commercial-ops/lpc-post-campaign',
    Component: lazy(() => import('./LPCPostCampaign/LPCPostCampaignPage')),
  },
  {
    pageId: 'flash-supply-forecasts',
    path: '/commercial-ops/flash-supply-forecasts',
    Component: lazy(() => import('./FlashSupplyForecasts/FlashSupplyForecastsPage')),
  },
  {
    pageId: 'room-inventory-availability',
    path: '/commercial-ops/room-inventory-availability',
    Component: lazy(() => import('./RoomInventoryAvailability/RoomInventoryAvailabilityPage')),
  },
];

export default function CommercialReportPage() {
  const { user, isLoading } = useCurrentUser();
  const { pathname } = useLocation();
  const loading = (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
      <CircularProgress />
    </Box>
  );
  if (isLoading) return loading;
  const page = COMMERCIAL_REPORT_ROUTES.find((entry) => entry.path === pathname);
  if (!page) return <Navigate to="/commercial-ops" replace />;
  const Component = page.Component;
  return (
    <ProductPerformanceRouteGate user={user} isLoading={isLoading}>
      <Suspense fallback={loading}>
        <Component />
      </Suspense>
    </ProductPerformanceRouteGate>
  );
}
